<template>
  <div class="menuWeb">
    <!-- <b-button v-b-toggle.sidebar-right>Toggle Sidebar</b-button> no-header -->
    <b-sidebar id="menuWeb"  :title="'Hello, '+headerTitleuser" left :backdrop-variant="variant" backdrop  no-header shadow>
	<template v-slot:default="{ hide }">
		
				
		<header class="b-sidebar-header" >
			
			<b-link :href="urlProfil"> 
			<b-img v-bind="mainProps" rounded="circle" alt="" v-if="proImg=='' || proImg==null" :src="$root.MEDIAPATH+'noprofile.png'" class="img-circle navpp" ></b-img> 
			<b-img   v-else  v-bind="mainProps" rounded="circle" :src="$root.MEDIAPATH+'profiles/'+proImg" class="img-circle navpp" alt="img"  ></b-img>
			
			
			<strong >Hello, {{headerTitleuser}}</strong>
			</b-link>
			<button type="button" aria-label="Close" class="close text-dark" @click="hide(),closebackBrandmenu()">
			<b-icon icon="x"></b-icon>
			</button>
			
		</header>
				
		
		<div class="w-100 h-100 submenuweb mt-4" v-if="isHiddenparnt">
			<b-link @click="closebackmenuparnt()" class="backbtnLinkn">
			<b-row class="backnev">
				<b-col >
					<span class="arrow"><i class="fa fa-arrow-left" aria-hidden="true"></i></span> <span class="mainmenu">MAIN MENU </span>
				</b-col>
				
				
			</b-row>
			</b-link>
			<!--{{menuList[0]['child'][0]['child']}}-->
			<sidebar-menu :collapsed="collapsed" :showChild="true" :menu="menuListparent" :theme="selectedTheme" :show-one-child="true" @item-click="onItemClick"></sidebar-menu>
		</div>
	
		<div class="w-100 h-100 submenuweb mt-4" v-if="isHidden">
			<b-link @click="closebackmenu()" class="backbtnLinkn">
			<b-row class="backnev">
				<b-col >
					<span class="arrow"><i class="fa fa-arrow-left" aria-hidden="true"></i></span> <span class="mainmenu">MAIN MENU </span>
				</b-col>
				
				
			</b-row>
			</b-link>
			<!--{{menuList[0]['child'][0]['child']}}-->
			<sidebar-menu :collapsed="collapsed" :showChild="true" :menu="menuList" :theme="selectedTheme" :show-one-child="true"
			></sidebar-menu>
		</div>
		<div class="w-100 h-100 submenuweb mt-4 brandPael" v-if="isbrandHidden">
			<b-link @click="closebackBrandmenu()" class="backbtnLinkn">
			<b-row class="backnev">
				<b-col >
					<span class="arrow"><i class="fa fa-arrow-left" aria-hidden="true"></i></span> <span class="mainmenu">BRANDS LIST </span>
				</b-col>
				
				
			</b-row>
			</b-link>
				<div class="alphabet">
				<!--
				 <select v-model="selectedLetter">
					<option :value="undefined">None</option>
					<option v-for="a in alphabet" :value="a" :key="a">{{a}}</option>
				  </select> -->
				  <ul class="p-0">
					<li>
						<b-link @mouseover="selectedLetter=''" :class="{ active : selectedLetter=='' }">*</b-link>
					</li>
					<li v-for="a in alphabet" :key="a">
						<b-link @mouseover="selectedLetter=a" :class="{ active : selectedLetter==a }" >{{a}}</b-link>
					</li>
					<li>
						<b-link @mouseover="selectedLetter='#'" :class="{ active : selectedLetter=='#' }">#</b-link>
					</li>
				  
				  </ul>
				</div>
			<div class="v-sidebar-menu vsm_expanded vsm_white-theme" style="width:90% !important;">
			
			
				<!--<ul class="brandList" v-if="brandallList.length>0">
					<li v-for="brandOb in brandallList" :key="brandOb.id">
					<a :href="'/brand/'+brandOb.urlslug">{{brandOb.brand_name}}</a>
					</li>
				</ul>
				<ul class="brandList" v-else>
					<li class="align-center">No brands found!</li>
				</ul>-->
				
				<ul class="brandList" v-if="filteredNames.length>0">
					<li v-for="brandOb in filteredNames" :key="brandOb.id">
					<a :href="'/brand/'+brandOb.urlslug">{{brandOb.brand_name}}</a>
					</li>
				</ul>
				<ul class="brandList" v-else>
					<li class="align-center">No brands found!</li>
				</ul>
				<!--
				<ul>
				<li v-for="brandOb in filteredNames" :key="brandOb.id">{{brandOb.brand_name}}</li>
			  </ul>
			  <p v-if="!filteredNames.length">No names for that letter</p> -->
				
			</div>
			
			
		</div>
	
	
	<div class="v-sidebar-menu vsm_expanded vsm_white-theme mt-4" style="max-width: 350px;"> 
		<div class="vsm--scroll-wrapper">
			<div class="vsm--list">
				<div class="vsm--item vsm--item_open">
					<a target="_self" href="#" class="vsm--link vsm--link_level-1 vsm--link_hover"><!----> <span class="vsm--title">Trending</span> <!----> <div class="vsm--arrow vsm--arrow_open"></div></a>
					<div class="vsm--dropdown">
						<div class="vsm--list">
						
						
						
						<div class="vsm--item"><a href="#" class="vsm--link vsm--link_level-2" target="_self" @click="openBrandmenu()"><!----> <span class="vsm--title">Brands</span> <!----> <!----></a> <!----></div>
						<div class="vsm--item"><a href="/offers" class="vsm--link vsm--link_level-2" target="_self"><!----> <span class="vsm--title">Offers</span> <!----> <!----></a> <!----></div>
						<div class="vsm--item"><a href="/women-indian-wear" class="vsm--link vsm--link_level-2" target="_self"><!----> <span class="vsm--title">Best Sellers</span> <!----> <!----></a> <!----></div>
						
						<div class="vsm--item"><a href="/videos" class="vsm--link vsm--link_level-2" target="_self"><!----> <span class="vsm--title">Watch & Buy</span> <!----> <!----></a> <!----></div>
						
						</div>
						</div>
				</div>
				
				
			</div> <!---->
		</div>  
			<button class="vsm--toggle-btn"></button>
	</div>
	<div class="v-sidebar-menu pt-0 vsm_expanded vsm_white-theme" style="max-width: 350px;"> <div class="vsm--scroll-wrapper">
		<div class="vsm--list">
			<div class="vsm--item"><a target="_self" href="#" class="vsm--link vsm--link_level-1" @click="openSubmenu(0)"><!----> <span class="vsm--title">Women</span> <!----> <div class="vsm--arrow"></div></a> <!----></div>
			<div class="vsm--item"><a target="_self" href="#" class="vsm--link vsm--link_level-1" @click="openSubmenu(5)"><!----> <span class="vsm--title">Men</span> <!----> <div class="vsm--arrow"></div></a> <!----></div>
			<div class="vsm--item"><a target="_self" href="#" class="vsm--link vsm--link_level-1" @click="openSubmenu(1)"><!----> <span class="vsm--title">Cosmetics</span> <!----> <div class="vsm--arrow"></div></a> <!----></div>
			<div class="vsm--item"><a target="_self" href="#" class="vsm--link vsm--link_level-1" @click="openSubmenu(2)"><!----> <span class="vsm--title">Organic</span> <!----> <div class="vsm--arrow"></div></a> <!----></div>
			<div class="vsm--item"><a target="_self" href="#" class="vsm--link vsm--link_level-1" @click="openSubmenu(3)"><!----> <span class="vsm--title">Home Essentials</span> <!----> <div class="vsm--arrow"></div></a> <!----></div>
			
			<!-- <div class="vsm--item"><a target="_self" href="#" class="vsm--link vsm--link_level-1" @click="openSubmenu(4)"> <span class="vsm--title">Indian Crafts</span> <div class="vsm--arrow"></div></a> </div> -->
			
	</div> <!----></div>  <button class="vsm--toggle-btn"></button></div>
	<!--<sidebar-menu :collapsed="collapsed" :showChild="false" :menu="menuParent" :theme="selectedTheme" :show-one-child="true"
	@item-click="onItemClick" class="pt-0"></sidebar-menu> -->
	
	
        <!-- <div class="px-3 py-2">
          <b-button variant="primary" block @click="hide">Close Sidebar</b-button>
          <p>foo</p>
          <b-img src="http://placekitten.com/200/200" fluid thumbnail></b-img>
        </div> -->
      </template>	
	
	<!--	
	<sidebar-menu :collapsed="collapsed" :showChild="false" :menu="menu" :theme="selectedTheme" :show-one-child="false"
	></sidebar-menu> -->
				

				

          
	
	
					
		
		<template #footer="{ hide }">
				<div class="traingPro"><b-button href="/training" pill variant="outline-secondary" size="sm">Training Registration</b-button></div>
			
				<b-row class="m-0 pt-2 pb-2">
					<b-col cols="6" class="ppb">
					<b-link :href="urlWhatapp" target="_blank" class="mpp" @click="hide"> <i class="fa fa-whatsapp chn" aria-hidden="true"></i> Chat Now!</b-link> 
					
					</b-col>
					<b-col cols="6 p-0" class="ppb text-center">
					<b-link href="/survey"  class="mpp" @click="hide"> 
					<i class="fa fa-wpforms ffb" aria-hidden="true"></i> Feedback Form</b-link> 
					
					</b-col>
				
					
					
				</b-row>
				
				
				
		</template>
		
		
		
      
    </b-sidebar>
	
		 <!--<b-sidebar id="menuWebsub"  title="Back" left :backdrop-variant="variant"  no-header backdrop shadow>
			<div v-if="menuMe=='Return'"> Return Data</div>
			<div v-if="menuMe=='Shipping'"> Shipping Data</div>
		 sdsdfsdfsf sdfsd 
		 </b-sidebar> -->
  
	
	
  </div>
</template>
<script> 
/* const separator = {
  template: '<hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">'
}; */
	//var today 	= new Date();
	//var timenow = '?'+today.getHours()+ today.getMinutes()+today.getSeconds();
	var timenow ='';
  import '@/assets/webpleftnave.scss';
  
  function genCharArray(charA, charZ) {
		var a = [], i = charA.charCodeAt(0), j = charZ.charCodeAt(0);
		for (; i <= j; ++i) {
			a.push(String.fromCharCode(i));
		}
		return a;
	}
export default {
  name: 'MenuPanel',
  components: {
  
  },
  props: {
    brandallList: { type: Array },
  },
  created () {
  	this.alphabet = genCharArray('a','z')
  },
  mounted(){
  //this.inLodcard;
  var rolesUser=this.$root.customer_info.role;
  if(rolesUser>0){
		this.headerTitleuser = this.$root.customer_info.username;
		this.proImg = this.$root.customer_info.image;
	//this.$session.get('customer_info').image;
	if(rolesUser==1){
		this.urlProfil	= '/admin/dashboard';
	}else if(rolesUser==2){
		this.urlProfil	= '/seller/dashboard';
	}else if(rolesUser==3){
		this.urlProfil	= '/agent/dashboard';
	}else if(rolesUser==4){
		this.urlProfil	= '/customer/dashboard';
	}else{
		this.urlProfil	= '/login';
	}
	
	
  }
  
		if(window.innerWidth < 700){
			//this.urlWhatapp='https://wa.me/send?text=&phone=918920670756';
			this.urlWhatapp='https://api.whatsapp.com/send?text=&phone=918920670756';
		 }
  
	
  },
  computed: {
    filteredNames () {
      let names = this.brandallList;    
      if (this.selectedLetter!='') {
			names = names.filter((name) => {
        	let firstLetter = name.brand_name.charAt(0).toLowerCase()
          return firstLetter === this.selectedLetter
        })
      }
	  
	 
	  
	  
      return names
    }
  },
  data() {
    return{
	 isHiddenparnt: false,
	 isHidden: false,
	 isbrandHidden: false,
      modaldata_qty: 1,
	  variant:'dark',
	  cartHeader:'',
	  headerTitleuser:'Sign in',
	  proImg:'',
	  urlProfil:'/login',
	  
		themes: ['', 'white-theme'],
		selectedTheme: 'white-theme',
		collapsed: false,
		menuMe:'',
		mainProps: { blank: false, blankColor: '#777', width: 30, height: 30, class: 'm1 mr-2' },
		menuParent:[ 
				  {
					title: 'Women',
					child: [
					  {
						title: "Indian Wear",
						
					  }, 
					  {
						title: "Western Wear",
					  },
					  {
						title: "Nightdress & Lingerie",
					  }, 
					  {
						title: "Sports Wear",
					  },
					  {
						title: "Women Accessories",
					  },{
						title: "Women Footwear",
					  }
					]
				  },
				  {
					title: 'Cosmetics',
					child:[
						  {
							title:"Makeup",
						  },{
							title:"Skin Care",
							
						  },{
							title:"Hair Care",
						  },{
							title:"Fragrances",
						  },{
							title:"Personal Care",
						  },
					  ]
				  
				  },
				  { 
					title: 'Organic',
					child:[
						  {
							href:"/skin-nutrition",
							title:"Skin Nutrition",
						  },{
							href:"/hair-nutrition",
							title:"Hair Nutrition"
						  },{
							href:"/kids-nutrition",
							title:"Kid's Nutrition"
						  },{
							href:"/ayurvedic-immunity-booster",
							title:"Ayurvedic Immunity Booster"
						  },
						  ]
					},
				{ title: 'Home Essentials',
				child:[
					  {					
						title:"Home Decor",
						
					  },
					  /*{					
						title:"Living Room",
						
					  }, */
					  {					
						title:"Arts and Crafts",
						
					  },
					  {					
						title:"Books",
						
					  },{				
						title:"Kitchen & Dining",
					  },{				
						title:"Pet Care",
					  }, 
					  ]
				},
				{ title: 'Indian Crafts',
					child:[
						  {
							title:"Handloom",
							
						  },{
							title:"Decor",
							
						  },{
							title:"Ethnic Wear",
							
						  },{
							title:"Accessories",
							
							
						  }
						 
					  ]
				},
				{
					title: 'Men',
					child: [
					  {
						title: "Top Wear",
						
					  }, 
					  {
						title: "Bottom Wear",
					  },
					  {
						title: "Indian & Festival Wear",
					  }, 
					  {
						title: "Nightdress & Innerwear",
					  },
					  {
						title: "Sportswear",
					  },{
						title: "Men Accessories",
					  },{
						title: "Men Footwear",
					  },{
						title: "Men's Grooming",
						href:"/mens-grooming",
					  }
					]
				  },

				],
		menu: [
				  
		 
		  { title: 'Women',
			child: [
			  {
				title: "Indian Wear",
				child: [
					{
						href:"/kurtas-suits"+timenow,
						title:"Kurtas Suits"	
					},{
						href:"/kurtis-tops"+timenow,
						title:"Kurtis & Tops"	
					},{
						href:"/leggings-salwars",
						title:"Leggings & Salwars"	
					},{
						href:"/skirts-palazzos",
						title:"Skirts & Palazzos"	
					},{
						href:"/sarees",
						title:"Sarees"	
					},{
						href:"/women-dress-materials",
						title:"Dress Materials"	
					},{
						href:"/lehenga-choli",
						title:"Lehenga Choli"	
					},{
						href:"/dupatta-shawls",
						title:"Dupatta & Shawls"	
					},{
						href:"/women-jackets",
						title:"Jackets"	
					},{
						href:"/women-ethnic-wear",
						title:"Ethnic Wear"	
					}
				]
			  },{
				title: "Western Wear",
				child: [
					{
						href:"/gowns-dresses",
						title:"Gowns & Dresses"	
					},{
						href:"/jumpsuits",
						title:"Jumpsuits"	
					},{
						href:"/shorts-skirts",
						title:"Shorts & Skirts"	
					},{
						href:"/women-sweaters-sweatshirts",
						title:"Sweaters & Sweatshirts"	
					},{
						href:"/tops-t-shirts",
						title:"Tops & T-Shirts"	
					},{
						href:"/women-jeans-pants",
						title:"Jeans & Pants"	
					}
				]
			  },{
				title: "Nightdress & Lingerie",
				child: [
					{
						href:"/women-sleepwear",
						title:"Sleepwear"	
					},{
						href:"/women-loungewear",
						title:"Loungewear"	
					},{
						href:"/lingerie",
						title:"Lingerie"	
					},{
						href:"/women-briefs",
						title:"Briefs"	
					}
				]
			  },{
				title: "Sports Wear",
				child: [
					{
						href:"/women-sports-wear-clothing",
						title:"Clothing"	
					},{
						href:"/women-sports-footware",
						title:"Footware"	
					},{
						href:"/women-sports-accessories",
						title:"Sports Accessories"	
					}
				]
			  },{
				title: "Women Accessories",
				child: [
					{
						href:"/handbags-clutches",
						title:"Handbags & Clutches"	
					},{
						href:"/women-jewellery",
						title:"Jewellery"	
					},{
						href:"/women-watches",
						title:"Watches"	
					},{
						href:"/women-sunglasses",
						title:"Sunglasses"	
					},{
						href:"/women-hair",
						title:"Hair"	
					}
					
				]
			  },
			  {
				title: "Women Footwear",
				child: [
					{
						href:"/women-shoes",
						title:"Shoes"	
					},{
						href:"/women-sandals",
						title:"Sandals"	
					},{
						href:"/women-sports-shoes",
						title:"Sports Shoes"	
					},{
						href:"/women-kohlapuri",
						title:"Kohlapuri"	
					}
				]
			  },			  
			  
			]
		  },
		  { title: 'Cosmetics',
			child:[
				  {
					title:"Makeup",
					child:[
						  {
							title:"Face",
								child:[
								  {
									href:"/cosmetics/foundation",
									title:"Foundation"
								  },
								  {
									href:"/cosmetics/compact-powder",
									title:"Compact Powder"
								  },{
									href:"/cosmetics/concealer",
									title:"Concealer"
								  },{
									href:"/cosmetics/blushes",
									title:"Blushes"
								  },{
									href:"/cosmetics/bronzers",
									title:"Bronzers"
								  },{
									href:"/cosmetics/highlighters-illuminators",
									title:"Highlighters & Illuminators"
								  },{
									href:"/cosmetics/primers",
									title:"Primers"
								  },{
									href:"/cosmetics/sindoors",
									title:"Sindoors"
								  },
								 ]
							
						  },{
							title:"Eyes",
								child:[
								  {
									href:"/cosmetics/kajal-kohls",
									title:"Kajal & Kohls"
								  },{
									href:"/cosmetics/eyeliners",
									title:"Eyeliners"
								  },{
									href:"/cosmetics/mascaras",
									title:"Mascaras"
								  },{
									href:"/cosmetics/eyeshadow",
									title:"Eyeshadow"
								  },{
									href:"/cosmetics/eye-concealer",
									title:"Eye Concealer"
								  },{
									href:"/cosmetics/eyebrow-colors",
									title:"Eyebrow Colors"
								  },
								 ]
							
						  },{
							title:"Lips",
								child:[
								  {
									href:"/cosmetics/Lipstick",
									title:"Lipstick"
								  },{
									href:"/cosmetics/lip-glosses",
									title:"Lip Glosses"
								  },{
									href:"/cosmetics/lip-liners",
									title:"Lip Liners"
								  },
								 ]
						  },{
							title:"Nails",
								child:[
								  {
									href:"/cosmetics/nail-gel",
									title:"Nail Gel"
								  },{
									href:"/cosmetics/nail-polish",
									title:"Nail Polish"
								  },{
									href:"/cosmetics/manicure",
									title:"Manicure"
								  },
								 ]
						  }
						 ]
				  },{
					title:"Skin Care",
					child:[
						  {
							href:"/cosmetics/cleansers-toners",
							title:"Cleansers & Toners"
						  },{
							href:"/cosmetics/moisturizers",
							title:"Moisturizers"
						  },{
							href:"/cosmetics/eye-care",
							title:"Eye Care"
						  },{
							href:"/cosmetics/sun-care",
							title:"Sun Care"
						  },{
							href:"/cosmetics/masks",
							title:"Masks"
						  }
						 ]
					
				  },{
					title:"Hair Care",
					child:[
						  {
							href:"/cosmetics/shampoo-conditioner",
							title:"Shampoo & Conditioner"
						  },{
							href:"/cosmetics/hair-styling-and-treatment",
							title:"Hair Styling and Treatment"
						  },{
							href:"/cosmetics/tools-and-accessories",
							title:"Tools and Accessories"
						  },
						 ]
					
					
				  },{
					title:"Fragrances",
						child:[
						  {
							href:"/cosmetics/men-fragrances",
							title:"Men's"
						  },{
							href:"/cosmetics/women-fragrances",
							title:"Women's"
						  },{
							href:"/cosmetics/unisex-fragrances",
							title:"Unisex"
						  }
						  ]
				  },
				  {
					title:"Personal Care",
					child:[
						  {
							href:"/cosmetics/bath-body-care",
							title:"Bath & Body Care"
						  },{
							href:"/cosmetics/feminine-hygiene",
							title:"Feminine Hygiene"
						  },{
							href:"/cosmetics/mens-grooming",
							title:"Men's Grooming"
						  }
						 ]
					
				  }
			  
			  ]
		  
		  },
		  { title: 'Organic',
			child:[
				  {
					href:"/skin-nutrition",
					title:"Skin Nutrition",
				  },{
					href:"/hair-nutrition",
					title:"Hair Nutrition"
				  },{
					href:"/kids-nutrition",
					title:"Kid's Nutrition"
				  },{
					href:"/ayurvedic-immunity-booster",
					title:"Ayurvedic Immunity Booster"
				  },
				  ]
			},
		  { title: 'Home Essentials',
			child:[
				  {					
					title:"Home Decor",
					child:[
					  {					
						href:"/bedding",
						title:"Bedding"
					  },{					
						href:"/bedroom-furnishings",
						title:"Bedroom Furnishings"
					  }
					  /* ,{					
						href:"/bedroomfurniture",
						title:"Home DecorFurniture"
					  }*/
					 ]
				  },{					
					title:"Living Room",
					child:[
					  {					
						href:"/living-room-furnishings",
						title:"Living Room Furnishings"
					  }
					  /*,{					
						href:"/living-room-furniture",
						title:"Furniture"
					  }*/
					 ]
				  },{					
					title:"Arts and Crafts",
					child:[
					  {					
						href:"/handicrafts",
						title:"Handicrafts"
					  },{					
						href:"/handloom-linen",
						title:"Handloom Linen"
					  },
					  /* {					
						href:"/decoratives",
						title:"Decoratives"
					  }, */
					 ]
				  },{					
					title:"Books",
					child:[
					  {					
						href:"/lifestyle-hobby",
						title:"Lifestyle & Hobby"
					  },{					
						href:"/healthy-living",
						title:"Healthy Living"
					  },
					  {					
						href:"/literature",
						title:"Literature"
					  },{					
						href:"/school-books",
						title:"School Books"
					  },{					
						href:"/self-help",
						title:"Self-Help"
					  },{					
						href:"/children",
						title:"Children"
					  },{					
						href:"/fiction-books",
						title:"Fiction Books"
					  },{					
						href:"/economics-business",
						title:"Economics & Business"
					  },
					 ]
				  },{				
					title:"Kitchen & Dining",
					href:"/kitchen-dining",
					child:[
						 {					
						href:"/Ready-To-Eat-Cook",
						title:"Ready to Eat & Cook"
						},
					  {					
						href:"/cookware",
						title:"Cookware"
					  },{					
						href:"/bakeware",
						title:"Bakeware"
					  }
					  /*{					
						href:"/utility",
						title:"Utility"
					  },*/
					 ]
				  },{				
					title:"Pet Care",
					href:"/pet-care",
					 child:[
					  {					
						href:"/food-treats",
						title:"Food & Treats"
					  },{					
						href:"/accessories-toys",
						title:"Accessories & Toys"
					  },
					 ]
				  }, /*{				
					title:"Appliances",
					child:[
					  {					
						href:"/small-appliances",
						title:"Small Appliances"
					  },{					
						href:"/large-appliances",
						title:"Large Appliances"
					  },{					
						href:"/floor-care",
						title:"Floor Care"
					  },
					 ]
				  },{				
					title:"Outdoor",
					href:"/outdoor",
					/* child:[
					  {					
						href:"/outdoor-furniture",
						title:"Furniture"
					  }
					 ]
				  },*/
				  
				  
				  ]
			},
		  { title: 'Indian Crafts',
				child:[
					  {
						title:"Handloom",
						child:[
							  {					
								href:"/sarees",
								title:"Sarees"
							  },{					
								href:"/suites",
								title:"Suites"
							  },{					
								href:"/shawls-and-stoles",
								title:"Shawls & Stoles"
							  },{					
								href:"/handloom-fabrics",
								title:"Fabrics"
							  },
							  ]
						
					  },{
						title:"Decor",
						child:[
							  {					
								href:"/decor-living-room",
								title:"Living Room"
							  },{					
								href:"/decor-bedroom",
								title:"Home Decor"
							  },{					
								href:"/decor-bathroom",
								title:"Bathroom"
							  },
							 ]
					  },{
						title:"Ethnic Wear",
						child:[
							  {					
								href:"/ethnic-wear-sarees",
								title:"Sarees"
							  },{					
								href:"/ethnic-wear-suites",
								title:"Suites"
							  },{					
								href:"/ethnic-wear-shawls-and-stoles",
								title:"Shawls & Stoles"
							  },{					
								href:"/ethnic-wear-fabrics",
								title:"Fabrics"
							  },
							 ]
					  },{
						title:"Accessories",
						child:[
							  {					
								href:"/indian-crafts-jewellery",
								title:"Jewellery"
							  },
							  /* {					
								href:"/indian-crafts-handbags",
								title:"Handbags"
							  },*/
							  {					
								href:"/indian-crafts-home-essentials",
								title:"Home Essentials"
							  },
							  ]
						
					  }
					  /*,{
						title:"Organic Products",
							child:[
							  {					
								href:"/organic-products-skin-nutrition",
								title:"Skin Nutrition"
							  },{					
								href:"/organic-products-hair-nutrition",
								title:"Hair Nutrition"
							  },{					
								href:"/organic-products-kids-nutrition",
								title:"Kid's Nutrition"
							  },{					
								href:"/ayurvedic-immunity-booster",
								title:"Ayurvedic Immunity Booster"
							  },
							  ]
					  }*/
				  ]
			},
			{ title: 'Men',
			child: [
			  {
				title: "Top Wear",
				child: [
					{
						href:"/men-t-shirts",
						title:"T Shirts"	
					},{
						href:"/men-formal-shirts",
						title:"Formal Shirts"	
					},{
						href:"/men-casual-shirts",
						title:"Casual Shirts"	
					},{
						href:"/men-sweaters-sweatshirts",
						title:"Sweaters & Sweatshirts"	
					},{
						href:"/men-jackets",
						title:"Jackets"	
					},{
						href:"/men-suits",
						title:"Suits"	
					}
				]
			  },{
				title: "Bottom Wear",
				child: [
					{
						href:"/men-jeans",
						title:"Jeans"	
					},{
						href:"/men-formal-trousers",
						title:"Formal Trousers"	
					},{
						href:"/men-casual-trousers",
						title:"Casual Trousers"	
					},{
						href:"/men-shorts",
						title:"Shorts"	
					}
					
				]
			  },{
				title: "Indian & Festival Wear",
				child: [
					{
						href:"/men-kurtas-kurta-sets",
						title:"Kurtas & Kurta Sets"	
					},{
						href:"/men-sherwanis",
						title:"Sherwanis"	
					},{
						href:"/nehru-jackets",
						title:"Nehru Jackets"	
					},{
						href:"/men-shawls-stoles",
						title:"Shawls & Stoles"	
					}
				]
			  },{
				title: "Nightdress & Innerwear",
				child: [
					{
						href:"/boxers",
						title:"Boxers"	
					},{
						href:"/briefs",
						title:"Briefs"	
					},{
						href:"/vests",
						title:"Vests"	
					},{
						href:"/men-sleepwear",
						title:"Sleepwear"	
					}
				]
			  },{
				title: "Sports Wear",
				child: [
					{
						href:"/men-sports-shoes",
						title:"Sports Shoes"	
					},{
						href:"/men-sports-sandals",
						title:"Sports Sandals"	
					},{
						href:"/men-active-t-shirts",
						title:"Active T-Shirts"	
					},{
						href:"/men-tracksuits",
						title:"Tracksuits"	
					},{
						href:"/men-jackets-sweatshirts",
						title:"Jackets & Sweatshirts"	
					} 
					
				]
			  },
			  {
				title: "Men Accessories",
				child: [
					{
						href:"/bags-belts-wallets",
						title:"Bags, Belts & Wallets"	
					},{
						href:"/men-jewellery",
						title:"Jewellery"	
					},{
						href:"/men-watches",
						title:"Watches"	
					},{
						href:"/men-sunglasses",
						title:"Sunglasses"	
					}
					
					
				]
			  },{
				title: "Men Footwear",
				child: [
					{
						href:"/men-sports-shoes",
						title:"Sports Shoes"	
					},{
						href:"/men-formal-shoes",
						title:"Formal Shoes"	
					},{
						href:"/men-casual-shoes",
						title:"Casual Shoes"	
					},{
						href:"/men-sandals",
						title:"Sandals"	
					},{
						href:"/men-kohlapuri",
						title:"Kohlapuri"	
					}
					
				]
			  },			  
			  
			]
		  },
		 
		],
		menuListparent:[],
		menuList:[],
		menuindexArray:{ 
					  "Indian Wear":'0,0', 
					  "Western Wear":'0,1',
					  "Nightdress & Lingerie":'0,2',
					  "Sports Wear":'0,3',
					  "Women Accessories":'0,4',
					  "Women Footwear":'0,5',
					  "Makeup":'1,0',
					  "Skin Care":'1,1',
					  "Hair Care":'1,2',
					  "Fragrances":'1,3',
					  "Personal Care":'1,4',
					  "Home Decor":'3,0',
					  "Living Room":'3,1',
					  "Arts and Crafts":'3,2',
					  "Books":'3,3',
					  "Kitchen & Dining":'3,4',
					  "Pet Care":'3,5',
					  "Handloom":'4,0',
					  "Decor":'4.1',
					  "Ethnic Wear":'4.2',
					  "Accessories":'4.3',
					  "Top Wear":'5,0',
					  "Bottom Wear":'5,1',
					  "Indian & Festival Wear":'5,2',
					  "Nightdress & Innerwear":'5,3',
					  "Sportswear":'5,4',
					  "Men Accessories":'5,5',
					  "Men Footwear":'5,6',
					  
					},
		urlWhatapp:'https://web.whatsapp.com/send?text=&phone=918920670756',
		 alphabet: [],
		 selectedLetter: '',

    }
  },
  methods:{
	/* inLodcard(){
	this.cartHeader ='
	} */
	openMymenu(l1,l2){
		//console.log(l1+','+l2);
		this.isHidden=true;
		this.isbrandHidden=false;
		var menuList= this.menu;
		this.menuList = menuList[l1]['child'][l2]['child'];
	},closebackmenuparnt(){
		this.isHidden=false;
		this.isHiddenparnt=false;
	},closebackmenu(){
		this.isHidden=false;
		this.isHiddenparnt=true;
		//this.isbrandHidden=false;
		
	},
	openBrandmenu(){
		this.isHidden=false;
		this.isbrandHidden=true;
	},closebackBrandmenu(){
		this.isHidden=false;
		this.isbrandHidden=false;
		this.isHiddenparnt=false;
	},hide(){
		this.isHidden=false;
		this.isbrandHidden=false;
		this.isHiddenparnt=false;
	},
	onItemClick(event, item, node) {
		console.log(event+','+item+''+node);
		//console.log(item.title);
		
		/*
		console.log(item.level);
		console.log(item.link_level);
		console.log(node.level);
		console.log(node.item); */
		//console.log(event.index);
		//if(node.level==2){
		//console.log(this.menuindexArray[item.title]);
		var menuEd= this.menuindexArray[item.title];
			
			var splIn = menuEd.split(',');
			this.openMymenu(splIn[0],splIn[1]);
		//}
	
	},
	openSubmenu(l1){
	this.isHiddenparnt=true;
		var menuList= this.menuParent;
		//this.menuList = menuList[0]['child'][l2]['child'];
		this.menuListparent = menuList[l1]['child'];
		//this.menuListparent = 
	}
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   lang="scss">
.menuWeb{
	
	.reg{
		width:95%;
		margin:5px;
	}
	.b-sidebar-footer{
		    /*margin-bottom: 15%;*/
			
	}
	.mpp{
		color: #757373 !important;
		font-size: 16px;
	}
	.ppb{
		  border-right: 1px solid #c6c6c6;
		  .chn{
		
					color:#25ac38;
					font-size: 19px;
				
		  } 
		  .ffb{
			
					color:red;
			
		  }
		  
	}
	.b-sidebar-footer{
	 background-color:#fff;
	}
	.close{
		position: absolute;
		z-index: 99999999999999999;
		margin-left: 95% !important;
		color: #ffffff !important;
		opacity: inherit;
		font-size: 48px !important;
	}
	.b-sidebar-header {
		
		text-transform: capitalize;
	}
	
	.submenuweb{
	
	/*border: 1px solid red;*/
    position: absolute;
    overflow: visible;
    z-index: 999 !important;
    background: aliceblue;
		.v-sidebar-menu{
			top:11%;
			padding-top:0px;
			width:100% !important;
			
		}
		
		
		.backnev{
				position: inherit;
				padding-top: 11%;
				padding-left: 5px;
				padding-right: 5px;
				background: #f1ebeb17;
				width: 100%;
				height: 71px;

				border-bottom: 1px solid #c6c6c6;
				.arrow{
					text-align: center;
					font-size: 16px;
					color: #575757d6;
					margin-left: 10px;
				}
				.mainmenu{padding-top: 3px;
				font-weight: 500;
				margin-left: 15px !important;
				}
				:hovre{
				border:1px solid red;
				}
			}
		.backbtnLinkn{
			text-decoration:none;
			
		}
		
	}
}


</style>
